var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageColumn',{staticClass:"create-order",attrs:{"paddingMainContents":false}},[_c('Panel',{staticClass:"text-blue-800",attrs:{"title":"สร้างใบส่งสินค้า"}},[_c('CommonFormWithDeliveryEditor',{attrs:{"edit":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }